
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class AuthCheckMixin extends Vue {
    async handleCallback (callable: () => Promise<void>): Promise<void> {
        try {
            await callable()
        } catch (err) {
            if (Number(err.message) === 401) {
                await this.$router.push('/')
            }
        }
    }
}
